<template>
    <div class="d-flex flex-column justify-content-center align-items-center">
        <div class="d-flex justify-content-center">
            <h2>Gerenciamento de categorias</h2>
        </div>
        <div class="col-8 mt-4">
            <div class="col-12 d-flex justify-content-center">
                <input type="text" 
                    class="col-6 form-control"
                    v-model="search"
                    placeholder="Pesquisa">
                <router-link
                    class="ml-5 btn btn-primary"
                    :to="{ name: 'NewCategory' }">
                    cadastrar
                </router-link>
            </div>
        </div>
        <div class="col-6 my-5">
            <DataTables
                v-model="categories"
                :headers="headers"
                :search="search"
                :tr-button="true"
                max_height="700px"
                @by-click-on-tr="Show"
                >

                <template v-slot:body="{ item }">
                    <td>
                        <b class="font-18">{{ item.descricao }}</b>
                    </td>
                    <td>
                        <i class="font-24 text-primary fal"
                            :aria="item.icone"
                            :class="`fa-${item.icone}`"></i>
                    </td>
                    <td>
                        {{ ParseDate(item.created_at) }}
                    </td>
                </template>
            </DataTables>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DataTables from './../../shared/DataTables'

const _ = require('lodash')

export default {
    name: "ManageCategories",
    components: {
        DataTables
    },
    data () {
        return {
            categories:         [],
            headers:            [
                { text: 'Descrição', value: 'descricao', sortable: true },
                { text: 'Ícone', value: 'icone', sortable: true },
                { text: 'Data de cadastro', value: 'created_at', sortable: true },
            ],
            search:         ""
        }
    },
    computed: {
        ...mapGetters('system', [
            'all_categories'
        ])
    },
    watch: {
        all_categories: {
            immediate: true,
            deep: true,
            handler(val)
            {
                this.categories = _.orderBy(val, 'id', 'asc')
            }
        }
    },
    methods: {
        ...mapActions('system', [
            'GetFaqItems'
        ]),
        Show(category)
        {
            this.$router.push({ name: 'EditCategory', params: {
                category_id: category.id
            }})
        },
        ParseDate(date)
        {
            if(date)
            {
                let new_date = date.substr(0, 10).split('-').reverse().join('/')

                return new_date
            }
            return ''
        }
    },
    beforeMount()
    {
        this.GetFaqItems()
    }
}
</script>

<style>

</style>